import type { BufferingMode } from '../enums';
import { FailedToLoadError } from '../errors';
import { BaseAsset } from './asset/BaseAsset';

export class BaseGroup extends BaseAsset {
    override _classType = 'BaseGroup';

    override async _bufferAtTime(time: number, bufferingMode: BufferingMode) {
        await Promise.all(
            this._getBaseAssetsShallow().map(async (child) => {
                try {
                    await child._bufferAtTime(time, bufferingMode);
                } catch (e: unknown) {
                    // If an asset fails to load during buffering, we don't want to fail buffering overall
                    // we'll let luminary do the best it can without this asset
                    if (!(e instanceof FailedToLoadError)) {
                        throw e;
                    }
                }
            }),
        );
    }

    override _propagatePlay() {
        this._getBaseAssetsShallow().forEach((child) => child._propagatePlay());
    }

    override _propagatePause() {
        this._getBaseAssetsShallow().forEach((child) => child._propagatePause());
    }

    override get canPlay() {
        return this._getBaseAssetsShallow().every((child) => child.canPlay);
    }

    override get isLoaded() {
        return this._getBaseAssetsShallow().every((child) => child.isLoaded);
    }

    override get isDoneTryingToLoad() {
        return this._getBaseAssetsShallow().every((child) => child.isDoneTryingToLoad);
    }

    override get _shouldLoad() {
        return true;
    }

    get duration(): number {
        return this.container.duration;
    }

    get isPlaying(): boolean {
        return this.container.isPlaying;
    }

    _getBaseAssetsShallow() {
        // We need to check for all base assets, not just "assets". For example,
        // The CaptionsManager is a BaseAsset with children but its not an "asset".
        return this.children;
    }
}
